import { fetchPropertyExclusiveOffersPageLogic } from './fetchPropertyExclusiveOffersPageLogic';

export const logic = [fetchPropertyExclusiveOffersPageLogic];
